<section
  class="container-custom"
  [ngStyle]="{ 'background-image': 'url(' + backgroundImage + ')' }"
>
  <div class="carrosselContainer">
    <div class="text-center-custom">
      <h2 class="title">{{ title }}</h2>

      <p *ngIf="subtitle" class="mt-5">{{ subtitle }}</p>
    </div>
    <swiper
      [slidesPerGroup]="1"
      [breakpoints]="myConfig"
      [navigation]="true"
      class="padding-custom"
      [ngClass]="'body-swiper'"
    >
      <ng-template *ngFor="let item of cards; let i = index" swiperSlide>
        <div
          style="box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25)"
          class="card-custom"
        >
          <img
            *ngIf="item.img"
            class="icon"
            [src]="'/assets/img/icons/' + item.img"
            alt=""
          />
          <h2 class="title-two" [innerHTML]="item.title"></h2>
          <p
            style="font-size: 16px"
            class="m-0 text-center"
            [innerHTML]="item.text"
          ></p>
        </div>
      </ng-template>
    </swiper>
    <footer class="text-center mt-4">
      <a class="text-blue" routerLink="/peca-azulzinha"
        >{{ cta ? cta : 'Peça a sua azulzinha' }}
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.1694 7.95975C14.4698 7.24584 13.7509 6.55437 13.0754 5.81263C11.9605 4.58955 10.8746 3.33506 9.77574 2.09493C9.51951 1.80667 9.4159 1.47348 9.52594 1.07657C9.62715 0.71288 9.86008 0.50907 10.1854 0.439026C10.4842 0.375268 10.7332 0.492885 10.9444 0.731752C12.8095 2.84564 14.6754 4.95771 16.5421 7.0707C16.9269 7.50623 17.3165 7.93549 17.7004 8.37192C18.1093 8.83708 18.0948 9.42256 17.6867 9.86707C16.3678 11.3039 15.0538 12.7461 13.7389 14.1882C12.8151 15.2021 11.8946 16.2195 10.9693 17.2316C10.5653 17.6734 10.0882 17.6904 9.72836 17.2917C9.38136 16.9074 9.3974 16.3407 9.77813 15.898C11.4705 13.9296 13.1654 11.9639 14.861 9.9991C14.869 10.0027 14.7172 10.0629 14.5839 10.0629C10.0713 10.0593 5.55959 10.0602 1.04704 10.0593C0.875147 10.0593 0.703226 10.0745 0.534547 9.9973C0.15221 9.82219 -0.0485808 9.43425 0.0100551 8.95562C0.0598554 8.54613 0.349806 8.23544 0.736963 8.18964C0.882348 8.17258 1.03014 8.17706 1.17713 8.17706C5.64952 8.17706 10.1211 8.17706 14.5935 8.17706H15.0216C15.0706 8.10522 15.1196 8.03339 15.1686 7.96155L15.1694 7.95975Z"
            fill="#005FAF"
          />
        </svg>
      </a>
    </footer>
  </div>
</section>
